import { atom } from "recoil";


const cartItemStatus = atom({
  key: 'cartItemStatus', 
  default: false, 
 });


 export default cartItemStatus;
